import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppHeaderService {
    private _headerVisible = new BehaviorSubject(true);
    readonly headerVisible = this._headerVisible.asObservable();
    showHeader(value: boolean) {
        this._headerVisible.next(value);
    }
    constructor() {}
}
